"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMG = exports.ICON_DIRECTION = exports.DEFAULT_CHIP_VALUES = void 0;
var DEFAULT_CHIP_VALUES = {
  BACKGROUND_COLOR: 'default',
  TEXT_COLOR: 'neutral',
  BORDER_COLOR: 'greyLight',
  FONT_SIZE: 'small',
  HOVER: {
    BACKGROUND_COLOR: 'default',
    TEXT_COLOR: 'secondary',
    BORDER_COLOR: 'secondary'
  },
  ACTIVE: {
    BACKGROUND_COLOR: 'blue',
    TEXT_COLOR: 'default',
    BORDER_COLOR: 'secondary'
  }
};
exports.DEFAULT_CHIP_VALUES = DEFAULT_CHIP_VALUES;
var ICON_DIRECTION = {
  left: 'left',
  right: 'right'
};
exports.ICON_DIRECTION = ICON_DIRECTION;
var IMG = {
  height: '42px',
  height_mobile: '30px',
  width: '42px',
  width_mobile: '30px',
  radius: '50%',
  padding: '4px',
  lpadding: '0px 16px 0px 8px',
  rpadding: '0px 8px 0px 16px'
};
exports.IMG = IMG;